



































import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganization,
  OversightOrganizationType,
} from '../../utils/OversightUtils';
import ProviderUtils, {
  ServiceProvider,
  ServiceProviderType,
} from '../../utils/ProviderUtils';

interface ParentOption {
  type: OversightOrganizationType;
  options: {
    text?: string;
    value: OversightOrganization;
  }[];
  selected?: OversightOrganization | OversightOrganization[];
}

export default mixins().extend({
  props: {
    value: {
      type: Object as () => ServiceProvider,
    },
  },
  computed: {
    type: {
      get(): any {
        return this.types?.find(
          (type) => type?.id === this.value?.serviceprovidertype?.id
        );
      },
      set(value: any) {
        this.value.serviceprovidertype = value;
        this.$emit('input', this.value);
      },
    },
    typeOptions(): any {
      return this.types?.map((type) => ({
        text: this.$translate(type.name),
        value: type,
      }));
    },
  },
  data: function(): {
    types?: ServiceProviderType[];
    parentOptions?: ParentOption[];
    oversightTypes?: OversightOrganizationType[];
    oversights?: OversightOrganization[];
  } {
    return {
      types: undefined,
      parentOptions: undefined,
      oversightTypes: undefined,
      oversights: undefined,
    };
  },
  async mounted() {
    try {
      const resp: any = await Promise.all([
        ProviderUtils.api.type.list(),
        OversightUtils.api.type.list(),
        OversightUtils.api.instance.list(),
      ]);

      this.types = resp[0];
      this.oversightTypes = resp[1];
      this.oversights = resp[2];
      this.parentOptions = this.generateParentOptions();
    } catch (error) {
      this.$handleAPIError(error);
    }
  },
  methods: {
    generateParentOptions(): ParentOption[] {
      const options = (type: OversightOrganizationType) => {
        return (
          this.oversights?.filter(
            (oversight) => oversight.oversighttype.id === type.id
          ) || []
        ).map((oversight) => ({
          text: this.$translate(oversight.name),
          value: oversight,
        }));
      };

      const selected = (type: OversightOrganizationType) => {
        return (
          options(type)
            .map((option) => option.value)
            ?.filter((oversight) =>
              this.value.parent
                ?.map((parent) => parent.id)
                .includes(oversight.id)
            ) || []
        );
      };

      return this.oversightTypes
        ?.filter((type) => type.scope.children_type === 'service_provider')
        .map((type) => ({
          type: type,
          options: options(type),
          selected: type.scope.mutually_exclusive_children
            ? selected(type)[0]
            : selected(type),
        })) as ParentOption[];
    },
    handleParentChange() {
      let merged: OversightOrganization[] = [];
      this.parentOptions
        ?.map((option) => option.selected)
        ?.forEach((selected) => {
          if (Array.isArray(selected)) {
            merged = merged.concat(selected);
          } else if (selected) {
            merged.push(selected);
          }
        });
      this.value.parent = merged;
      this.$emit('input', this.value);
    },
    handleTypeChange() {
      this.$emit('input', this.value);
    },
  },
});
